import type { OrganizationType, OrganizationTier } from "./types";

export const ORG_TYPE_LABELS: Record<OrganizationType, string> = {
  NGO: "NGO",
  NPO: "Non-Profit",
  COMMERCIAL: "Commercial",
};

/**
 * i18n key map for org-type labels. Resolve with `t()` at the render site.
 * `ORG_TYPE_LABELS` (raw English) is retained for the not-yet-localized
 * organization-settings feature that imports it.
 */
export const ORG_TYPE_LABEL_KEYS: Record<OrganizationType, string> = {
  NGO: "organizations.type.NGO",
  NPO: "organizations.type.NPO",
  COMMERCIAL: "organizations.type.COMMERCIAL",
};

export const ORG_TYPE_EMOJI: Record<OrganizationType, string> = {
  NGO: "🌍",
  NPO: "💚",
  COMMERCIAL: "🏢",
};

export const ORG_TYPES: OrganizationType[] = ["NGO", "NPO", "COMMERCIAL"];

export const ORG_TIER_LABELS: Record<OrganizationTier, string> = {
  SEED: "Seed",
  SCALE: "Scale",
  ENTERPRISE: "Enterprise",
};

export const ORG_TIER_DESCRIPTIONS: Record<OrganizationTier, string> = {
  SEED: "Up to 25 seats",
  SCALE: "Up to 499 seats",
  ENTERPRISE: "Unlimited seats",
};

/**
 * i18n key map for tier seat-limit descriptions. Resolve with `t()` at the
 * render site. `ORG_TIER_DESCRIPTIONS` (raw English) is retained for the
 * not-yet-localized organization-settings feature that imports it.
 */
export const ORG_TIER_DESCRIPTION_KEYS: Record<OrganizationTier, string> = {
  SEED: "organizations.tierDescription.SEED",
  SCALE: "organizations.tierDescription.SCALE",
  ENTERPRISE: "organizations.tierDescription.ENTERPRISE",
};

export const ORG_TIERS: OrganizationTier[] = ["SEED", "SCALE", "ENTERPRISE"];
